<template>
    <v-content>
        <v-row >
            <v-col class="title">
                Аудиоролики
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-dialog
                    v-model="dialog"
                    persistent
                    width="500"
                    >
                    <template v-slot:activator="{ on }">
                        <v-btn
                        color="primary"
                        v-on="on"
                        >
                        Создать новый ролик
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="name"
                                        placeholder="Название аудиозаписи"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        v-model="source"
                                        :items="sources"
                                        item-text="name"
                                        item-value="type"
                                        label="Источник аудиоролика"
                                        persistent-hint
                                    ></v-select>
                                </v-col>
                                <v-col  cols="12" v-if="source == 'text'">
                                    <v-switch
                                        v-model="gender"
                                        true-value="1"
                                        false-value="0"
                                        :label="gender==0 ? 'Женский голос' : 'Мужской голос'"
                                    ></v-switch>
                                    <v-textarea
                                        v-model="text_for_generation"
                                    ></v-textarea>
                                </v-col>
                                <v-col  cols="12" v-if="source == 'file'">
                                    <v-file-input 
                                        accept=".wav" 
                                        label="Аудио файл формата .wav"
                                        @change="handleFileSelect($event)"
                                        v-model="file_for_sending"
                                    ></v-file-input>
                                    <audio v-if="!!file" controls :src="file"></audio>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="green" @click="createRecord()">Сохранить</v-btn>
                            <v-btn color="red" @click="dialog=false">Отменить</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
            <v-list>
                <v-list-item
                    v-for="record in records"
                    :key="record.id"
                >
                    <v-list-item-content class="d-inline">
                        <v-list-item-title v-text="record.name"></v-list-item-title>
                        <audio controls :src="record.path"></audio>
                    </v-list-item-content>
                    <v-spacer/>
                    <v-list-item-action class="d-inline">
                        <v-btn icon @click="removeRecord(record)">
                            <v-icon color="grey lighten-1">mdi-delete</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
export default {
    name: 'recordsList',
    data() {
        return {
            dialog: false,
            source: null,
            sources: [
                {
                    name: 'Файл',
                    type: 'file'
                },
                {
                    name: 'Текст',
                    type: 'text'
                },
            ],
            name: '',
            text_for_generation: '',
            gender: 0,
            file: null,
            file_for_sending: null,
        }
    },
    created() {
        this.$store.dispatch('GET_RECORDS');
    },
    computed: {
        records() {
            return this.$store.getters.RECORDS;
        },
    },
    methods: {
        createRecord() {
            var data = {};
            switch (this.source) {
                case 'file':
                    data = {
                        name: this.name,
                        source: this.source,
                        file: this.file_for_sending,
                    };
                    break;
                case 'text':
                    data = {
                        name: this.name,
                        source: this.source,
                        text: this.text_for_generation,
                        gender: this.gender
                    };
                    break;
            
                default:
                    break;
            }

            if (data.hasOwnProperty("text") || data.hasOwnProperty("file")) {
                this.$store.dispatch('CREATE_RECORD', data)
                .then(() => {
                    this.$toaster.success('Запись создана');
                    this.$store.dispatch('GET_RECORDS');
                    this.dialog = false;
                })
                .catch(() => {
                    this.$toaster.error('Неизвестаная ошибка!');
                });
            }
            
        },
        removeRecord(record) {
            this.$store.dispatch('DELETE_RECORD', record.id)
                .then(() => {
                    this.$toaster.success('Запись удалена');
                    this.$store.dispatch('GET_RECORDS');
                })
                .catch(() => {
                    this.$toaster.error('Неизвестаная ошибка!');
                });
        },
        handleFileSelect(file) {
            if (file) {
                var reader = new FileReader();
                var _this = this;
                reader.onload = function(readerEvt) {
                    _this.file = 'data:audio/mpeg;base64,'+ btoa(readerEvt.target.result);
                }
                reader.readAsBinaryString(file);
            }
        }
    }
}
</script>

<style>

</style>